module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('li', {
    staticClass: "active",
    style: (_vm.getLiStyle()),
    attrs: {
      "klickbox-edit-item": "progress-bullet-active",
      "klickbox-edit-item-dad": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.active_item')
    }
  }, [_c('span', {
    staticClass: "kbx-subtitle",
    style: (_vm.getSpanStyle()),
    domProps: {
      "innerHTML": _vm._s(_vm.getSVG())
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kbx-number",
    style: (_vm.getNumberStyle())
  }, [_vm._v("2")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-550e7b71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/numeric/Active.vue
 ** module id = 832
 ** module chunks = 1
 **/